<template>
    <div class="mt-4 p-0 mr-0 ml-0 mb-0 d-print-none">
        <suspended-tenant-component v-if="tenant[0] && tenant[0].status && tenant[0].status == 'Suspenso'" />
        
        <template v-else>        
            <v-row dense class="d-print-none">
                <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                    <v-btn
                        @click.prevent="backFilter()" 
                        :class="$vuetify.breakpoint.mdAndDown ? 'caption' : $css_button"
                        outlined
                        :block="$vuetify.breakpoint.smAndDown"
                        :small="$vuetify.breakpoint.mdAndDown"
                    >
                        <v-icon left>
                            mdi-chevron-left
                        </v-icon>
                        pesquisa
                    </v-btn>
                </v-col>

                <template v-if="me.profile == 'Master' || me.profile == 'Gerente'">
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                        <v-btn
                            @click.prevent="portalSummary()" 
                            :class="$vuetify.breakpoint.mdAndDown ? 'caption' : $css_button"
                            outlined
                            :block="$vuetify.breakpoint.smAndDown"
                            :small="$vuetify.breakpoint.mdAndDown"
                        >
                            <v-icon left>
                                mdi-hub
                            </v-icon>
                            Portais
                        </v-btn>
                    </v-col>
                </template>

                <template v-if="properties && properties.meta && properties.meta.total && properties.meta.total > 0">
                    <template v-if="me.profile == 'Master' || me.profile == 'Gerente'">
                            <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                                <v-btn
                                    @click.prevent="property_export()" 
                                    :class="$vuetify.breakpoint.mdAndDown ? 'caption success' : $css_button + ' success'"
                                    :block="$vuetify.breakpoint.smAndDown"
                                    :loading="loading_excel"
                                    :small="$vuetify.breakpoint.mdAndDown"
                                >   
                                    <v-icon left>
                                        mdi-microsoft-excel
                                    </v-icon>
                                    excel 
                                </v-btn>
                            </v-col>

                            <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                                <v-btn
                                    @click.prevent="propertyExportCodeComma()" 
                                    :class="$vuetify.breakpoint.mdAndDown ? 'caption pink' : $css_button + ' pink'"
                                    :block="$vuetify.breakpoint.smAndDown"
                                    :loading="loading_property_export_code_comma"
                                    dark
                                    :small="$vuetify.breakpoint.mdAndDown"
                                >   
                                    <v-icon left>
                                        mdi-comma-box-outline
                                    </v-icon>
                                    Codigos
                                </v-btn>
                            </v-col> 

                            <template v-if="property_export_code_comma">
                                <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                                    <v-btn
                                        @click.prevent="copyListComa()" 
                                        :class="$vuetify.breakpoint.mdAndDown ? 'caption info' : $css_button + ' info'"
                                        :block="$vuetify.breakpoint.smAndDown"
                                        dark
                                        :small="$vuetify.breakpoint.mdAndDown"
                                    >   
                                        <v-icon left>
                                            mdi-comma-box-outline
                                        </v-icon>
                                        Copiar 
                                    </v-btn>
                                </v-col>
                                <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                                    <v-btn
                                        @click.prevent="openCloseDialog('Marcar Portal')" 
                                        :class="$vuetify.breakpoint.mdAndDown ? 'caption purple' : $css_button + ' purple'"
                                        :block="$vuetify.breakpoint.smAndDown"
                                        dark
                                        :small="$vuetify.breakpoint.mdAndDown"
                                    >   
                                        <v-icon left>
                                            mdi-checkbox-outline
                                        </v-icon>
                                        portal
                                    </v-btn>
                                </v-col>
                            </template> 
                    </template>
                </template>

                <template v-if="properties && properties.meta && properties.meta.total && properties.meta.total > 0">
                    <v-spacer></v-spacer>
                    <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'" class="text-right">  
                        <order-new-component 
                            :object="items_order"
                            @callLoadItems="changeOrder"
                        />
                    </v-col>
                </template>
            </v-row>

            <!--template v-if="properties && properties.meta && properties.meta.total && properties.meta.total > 0">
                <template v-if="me.profile == 'Master' || me.profile == 'Gerente'">
                    <v-row>
                        <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                            <v-btn
                                @click.prevent="property_export()" 
                                :class="$css_button + ' success'"
                                :block="$vuetify.breakpoint.smAndDown"
                                :loading="loading_excel"
                            >   
                                <v-icon left>
                                    mdi-microsoft-excel
                                </v-icon>
                                Exportar excel 
                            </v-btn>
                        </v-col>

                        <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                            <v-btn
                                @click.prevent="propertyExportCodeComma()" 
                                :class="$css_button + ' pink'"
                                :block="$vuetify.breakpoint.smAndDown"
                                :loading="loading_property_export_code_comma"
                                dark
                            >   
                                <v-icon left>
                                    mdi-comma-box-outline
                                </v-icon>
                                Codigos por virgula 
                            </v-btn>
                        </v-col> 

                        <template v-if="property_export_code_comma">
                            <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                                <v-btn
                                    @click.prevent="copyListComa()" 
                                    :class="$css_button + ' info'"
                                    :block="$vuetify.breakpoint.smAndDown"
                                    dark
                                >   
                                    <v-icon left>
                                        mdi-comma-box-outline
                                    </v-icon>
                                    Copiar códigos 
                                </v-btn>
                            </v-col>
                            <v-col :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'">
                                <v-btn
                                    @click.prevent="openCloseDialog('Marcar Portal')" 
                                    :class="$css_button + ' purple'"
                                    :block="$vuetify.breakpoint.smAndDown"
                                    dark
                                >   
                                    <v-icon left>
                                        mdi-checkbox-outline
                                    </v-icon>
                                    Marcar portal
                                </v-btn>
                            </v-col>
                        </template> 

                    </v-row>
                </template>
            </template-->

        
            <template v-if="properties && properties.meta && properties.meta.total && properties.meta.total > 0">
                <v-row v-if="properties.meta" class="mt-2 mb-2">    
                    <v-col cols="12" sm="12" md="6">
                        <div class="text-h6">Total: {{ properties.meta.total }} -  Página {{ properties.meta.current_page }} de {{ properties.meta.last_page }}</div>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <pagination-component 
                            :meta="properties.meta"
                            @page-changed="changePage"
                        />
                    </v-col>    
                </v-row>
                <v-row dense class="d-print-none">
                    <v-col>
                        <result-list v-if="properties.data" :items="properties.data" @callDestroyProperty="destroyProperty" />
                    </v-col>
                </v-row>
                <v-row v-if="properties.meta" class="mt-2 mb-2">    
                    <v-col cols="12" sm="6" md="6">
                        <div class="text-h6">Total: {{ properties.meta.total }} -  Página {{ properties.meta.current_page }} de {{ properties.meta.last_page }}</div>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <pagination-component 
                            :meta="properties.meta"
                            @page-changed="changePage"
                        />
                    </v-col> 
                    <v-col cols="12" sm="12" md="3">
                        <v-btn
                            @click.prevent="backFilter()" 
                            :class="$css_button"
                            outlined
                            :block="$vuetify.breakpoint.smAndDown"
                        >
                            <v-icon left>
                                mdi-chevron-left
                            </v-icon>
                            Voltar para pesquisa
                        </v-btn>
                    </v-col>
                </v-row>
            </template>

            <template v-else>
                <div class="mt-6" v-if="properties.meta">
                    <v-alert
                        type="error"
                    >
                        Nenhum registro encontrado. Verifique sempre se há filtros já selecionados  
                    </v-alert>
                </div>
            </template>

            <button-new v-if="can('Cadastra imóvel')" :params="{ route_name: 'admin.properties2.store' }" />



            <!-- Dialog Portal -->
            <v-dialog
                v-model="dialog.status"
                max-width="600px"
                class="d-print-none"
            >
                <v-card>
                    <v-card-title class="text-h6">
                        <span v-if="dialog.model">{{ dialog.model }}</span>
                        <v-spacer></v-spacer>
                        <v-btn icon @click="openCloseDialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-divider></v-divider>
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <portal-register-form v-if="dialog.model == 'Marcar Portal'" :object="property_export_code_comma.codigos" />
                            </v-col>    
                        </v-row>
                    </v-container>
                </v-card>                
            </v-dialog>
            <!-- End Dialog Portal -->
        </template>    
        
    </div>
</template>

<script>
import PaginationComponent from '@/components/pagination/PaginationComponent.vue';
import OrderNewComponent from '@/components/order/OrderNewComponent.vue';
import ResultList from './ResultList.vue';
import ButtonNew from '@/components/button_newregister/ButtonNew.vue';
import PortalRegisterForm from '@/components/portals/partials/PortalRegisterForm.vue'
import SuspendedTenantComponent from '@/components/suspendedtenant/SuspendedTenantComponent.vue'


import qs from 'qs';
import { mapGetters } from 'vuex';


export default {
    components: {
        ResultList,
        PaginationComponent,
        OrderNewComponent,
        ButtonNew,
        PortalRegisterForm,
        SuspendedTenantComponent
    },

    data () {
        return {
            dialog: {
                status: false,
                model: null
            },

            loading_excel: false,
            loading_property_export_code_comma: false,

            property_export_code_comma: null,

            properties: {},

            params: null,

            items_order: {
                current_order: { 
                    value: 'properties.data_atualizacao', 
                    description: 'Data de atualizaçāo',
                    sense: 'desc',
                    sense_description: 'maior -> menor',
                    params: ''
                },
                sense: [
                    { value: 'asc', description: 'menor -> maior' },
                    { value: 'desc', description: 'maior -> menor' },
                ],
                items:[
                    {
                        value: 'properties.valor_venda', 
                        description: 'Valor Venda'
                    },
                    {
                        value: 'properties.valor_locacao', 
                        description: 'Valor Locaçāo'
                    },
                    {
                        value: 'properties.data_atualizacao', 
                        description: 'Data de atualizaçāo'
                    },
                    {
                        value: 'properties.created_at', 
                        description: 'Data de cadastro'
                    },    
                ] 
            },
        }
    },  

    watch: {
        '$route.query': {
            immediate: true,
            deep: true,
            handler(newQuery) {
            const page = newQuery.page ? Number(newQuery.page) : 1;

            // Pegar order/sense da query se existirem, caso contrário manter o estado atual
            const orderFromQuery = newQuery.order || this.items_order.current_order.value;
            const senseFromQuery = newQuery.sense || this.items_order.current_order.sense;

            // Atualiza o estado local de ordenação (para refletir a URL)
            this.items_order.current_order.value = orderFromQuery;
            const foundOrder = this.items_order.items.find(m => String(m.value) === String(orderFromQuery));
            this.items_order.current_order.description = foundOrder ? foundOrder.description : '';

            this.items_order.current_order.sense = senseFromQuery;
            const foundSense = this.items_order.sense.find(s => String(s.value) === String(senseFromQuery));
            this.items_order.current_order.sense_description = foundSense ? foundSense.description : '';

            // Monta filtros com valores da query (order/sense já atualizados)
            const filters = {
                ...newQuery,
                page,
                order: orderFromQuery,
                sense: senseFromQuery
            };

            // Remove chaves vazias/nulas
            Object.keys(filters).forEach(k => {
                if (filters[k] == null || filters[k] === '') delete filters[k];
            });

            this.loadMoreProperties(filters);
            }
        }
    },


    
    mounted() {
       const query = { ...this.$route.query };

        // Corrige múltiplos status
        if (query.multiple_status && !Array.isArray(query.multiple_status)) {
            query.multiple_status = [query.multiple_status];
        }

        // Aplica order da URL SE existir
        if (query.order) {
            this.items_order.current_order.value = query.order;
        }

        // Aplica sense da URL SE existir
        if (query.sense) {
            this.items_order.current_order.sense = query.sense;
        }

        // Garante página válida
        const page = query.page ? Number(query.page) : 1;

        const filters = {
            ...query,
            page: page,
            order: this.items_order.current_order.value,
            sense: this.items_order.current_order.sense
        };

    },

    computed: {
        ...mapGetters('permissions', ['can']),

        me () {
          return this.$store.state.auth.me
        },

        tenant() {
            return this.$store.state.tenants.items.data    
        }
    },    

    methods: {
        
        async loadMoreProperties(params = null) {
            this.params = params;
            try {
                const response = await this.$store.dispatch('loadPromisseProperties', params);
                this.properties = response;

                this.$nextTick(() => {
                    window.scrollTo(0, 0);
                });
            } catch (error) {
                console.error('Erro ao carregar propriedades:', error);
                // Opcional: exibir mensagem ao usuário
                this.$toast.error('Falha ao carregar os dados. Tente novamente.');
            }
        },

        backFilter(){
            const filters = { ...this.$route.query}; // Cópia direta dos parâmetros
            
            this.$router.push({
                name: 'admin.properties2.filter',
                query: filters
            });
            
        },

        portalSummary(){
            this.$router.push({
                name: 'admin.properties2.property_portal_summary'
            });
        },

        changePage(page) {
            const query = { ...this.$route.query };
            const order = this.items_order.current_order.value;
            const sense = this.items_order.current_order.sense;

            // Garanta que a página seja um número válido
            const pageSafe = page && !isNaN(page) ? Number(page) : 1;

            const filters = {
                ...query,
                page: pageSafe,
                order,
                sense
            };

            // Remova valores undefined ou nulos
            Object.keys(filters).forEach(key => {
                if (filters[key] == null || filters[key] === '') {
                    delete filters[key];
                }
            });
            
            this.$router.push({
                query: filters
            });
        },

        changeOrder(params){
            this.items_order.current_order.value = params.order;
            const items = this.items_order.items.filter( model => model.value == params.order);
            if(items && items.length > 0){
                this.items_order.current_order.description = items[0].description;
            }

            this.items_order.current_order.sense = params.sense;
            const sense_items = this.items_order.sense.filter( model => model.value == params.sense);
            if(sense_items && sense_items.length > 0){
                this.items_order.current_order.sense_description = sense_items[0].description;
            }

            const filters = { ...this.$route.query, page: 1, order: params.order, sense: params.sense }; // Cópia direta dos parâmetros
            this.$router.push({
                query: filters
            });
            //this.loadMoreProperties(filters);
        },

        async property_export() {
            this.loading_excel = true;
            try {
                const response = await this.$store.dispatch('property_export', this.params);
                this.$snotify.success('Download concluído com sucesso!');
            } catch (error) {
                console.error('Erro ao carregar propriedades:', error);
                // Opcional: exibir mensagem ao usuário
                this.$toast.error('Falha ao carregar os dados. Tente novamente.');
            }
            this.loading_excel = false;
        },

        async propertyExportCodeComma() {
            this.loading_property_export_code_comma = true;
            this.property_export_code_comma = null
            try {
                this.property_export_code_comma = await this.$store.dispatch('property_export_code_comma', this.params);
            } catch (error) {
                console.error('Erro ao carregar propriedades:', error);
                // Opcional: exibir mensagem ao usuário
                this.$toast.error('Falha ao carregar os dados. Tente novamente.');
            }
            this.loading_property_export_code_comma = false;
        },

        copyListComa(){
            if(this.property_export_code_comma.codigos && this.property_export_code_comma.codigos != ''){
                navigator.clipboard.writeText(this.property_export_code_comma.codigos);
                this.$snotify.success(`List de imóveis copiado. Utilize o CTRL + V para colar`, 'Copia')
            }else{
                this.$snotify.error(`Códigos não encontrados`, 'Copia')
            }
        },

        openCloseDialog(model = null){
            if(model) { this.dialog.model = model }
            this.dialog.status = !this.dialog.status;
        },

        async destroyProperty(id) {    
            try {
                this.$store.dispatch('destroyProperty', id)
                        .then(() => {
                            // Remove localmente
                            this.properties.data = this.properties.data.filter(p => p.id !== id)

                            // Atualiza metadados
                            this.properties.meta.total -= 1
                            this.properties.meta.last_page = Math.ceil(this.properties.meta.total / this.properties.meta.per_page)
                            this.properties.meta.to = this.properties.data.length

                            this.$snotify.success(`Registro excluído com sucesso`, 'Exclusāo')
                        })
                        .catch(error => {
                            this.$snotify.error('error', error)
                        });
            } catch (error) {
                console.error('Erro ao excluir propriedade:', error)
            }
            
        }
    }
}

</script>
